var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editorRef",staticClass:"markdown-editer"}),_c('div',{attrs:{"id":"imagePreviewDiv"}}),_c('button',{staticStyle:{"display":"none"},attrs:{"id":"copyButton"}},[_vm._v("复制")])])
}
var staticRenderFns = []

export { render, staticRenderFns }